// React i hooks
import { memo } from "react";

// UI komponente
import { TableSearch } from "ui/components/Table/TableSearch";

// Tipovi i konstante
import { ResidualValueSearchResultsProps } from "./types";
import { initialDataWithPagination } from "services/api/consts";
import {
  CALCULATION_RESIDUAL_VALUE_SEARCH_COLUMNS,
} from "./consts";


const ResidualValueSearchResults: React.FC<ResidualValueSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  return (
    <>
      <TableSearch
        columns={CALCULATION_RESIDUAL_VALUE_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(ResidualValueSearchResults);
